module.exports = __webpack_public_path__ + "static/img/2014-B.b290d0d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2014-B.png
// module id = qIz/
// module chunks = 1